
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import './index.css';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { EnvironmentProvider } from './contexts/EnvironmentContext';
import { detectEnvironment } from './utils/environmentUtils';

const queryClient = new QueryClient();

// Ensure we have a valid DOM element to render to
const rootElement = document.getElementById("root");

if (!rootElement) {
  console.error("Root element not found! Create a div with id 'root' in your HTML file.");
} else {
  // Detect initial environment and convert to proper EnvironmentType
  const initialEnvironment = detectEnvironment();
  
  createRoot(rootElement).render(
    <React.StrictMode>
      <EnvironmentProvider initialEnvironment={initialEnvironment as 'development' | 'staging' | 'production'}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </EnvironmentProvider>
    </React.StrictMode>
  );
}
